import { Col, InfinityLoading, Row } from 'ui';
import type { EventWithSource } from '../../hooks';
import { InvitationListEmpty } from './invitation-list-empty';
import { NodeInvitationWidgetItem } from './node-invitation-widget-item';
import { RailsInvitationWidgetItem } from './rails-invitation-widget-item';

type P = {
  fetchNextPage: () => unknown;
  getPathToEventDetail: (id: string) => string;
  hasMoreData?: boolean;
  isFetching: boolean;
  items: EventWithSource[];
};

const InvitationWidgetItem = ({
  getPathToEventDetail,
  invitation: { event, source },
}: {
  getPathToEventDetail: (id: string) => string;
  invitation: EventWithSource;
}) => {
  switch (source) {
    case 'node':
      return <NodeInvitationWidgetItem getPathToEventDetail={getPathToEventDetail} invitation={event} />;
    case 'rails':
      return <RailsInvitationWidgetItem getPathToEventDetail={getPathToEventDetail} invitation={event} />;
  }
};

const InvitationsList = ({ fetchNextPage, getPathToEventDetail, hasMoreData, isFetching, items }: P) => {
  if (!isFetching && items.length === 0) {
    return <InvitationListEmpty />;
  }

  return (
    <Row gutter={['ms', 0]}>
      {items.map((invitation) => (
        <Col key={invitation.event.id} span={24}>
          <InvitationWidgetItem getPathToEventDetail={getPathToEventDetail} invitation={invitation} />
        </Col>
      ))}
      {isFetching || hasMoreData ? (
        <Col span={24}>
          <InfinityLoading hasMoreData={hasMoreData} isLoading={isFetching} onEnter={fetchNextPage} />
        </Col>
      ) : null}
    </Row>
  );
};

export default InvitationsList;
